module.exports = __webpack_public_path__ + "static/media/reddit-alien-brands.422193e5.svg";